var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17523_19011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2331 1.01654C10.526 0.723652 11.0009 0.723652 11.2938 1.01654L14.2938 4.01655C14.5867 4.30944 14.5867 4.78431 14.2938 5.07721L6.04376 13.3272C5.90311 13.4679 5.71234 13.5469 5.51343 13.5469H2.51343C2.09921 13.5469 1.76343 13.2111 1.76343 12.7969V9.79688C1.76343 9.59796 1.84245 9.4072 1.9831 9.26655L10.2331 1.01654ZM3.26343 10.1075V12.0469H5.20277L12.7028 4.54688L10.7634 2.60754L3.26343 10.1075Z",
    fill: "#707494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76343 16.5469C1.76343 16.1327 2.09921 15.7969 2.51343 15.7969H16.0134C16.4276 15.7969 16.7634 16.1327 16.7634 16.5469C16.7634 16.9611 16.4276 17.2969 16.0134 17.2969H2.51343C2.09921 17.2969 1.76343 16.9611 1.76343 16.5469Z",
    fill: "#707494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17523_19011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.263428 0.046875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgEditIcon);
export default __webpack_public_path__ + "static/media/TGEditIcon.6d9a1d1260442d2960e50341d30317f6.svg";
export { ForwardRef as ReactComponent };